module.exports = __webpack_public_path__ + "img/wisestats.a1dc1bb1.png";